import { render, staticRenderFns } from "./ListaFacturasAmerica.vue?vue&type=template&id=9aaed1c8"
import script from "./ListaFacturasAmerica.vue?vue&type=script&lang=js"
export * from "./ListaFacturasAmerica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports